import React from 'react';
import I18n from 'i18n-js';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';

import { Listing, NextBestAction } from '@reverbdotcom/commons/src/gql/graphql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';

import { INSIGHT, trackClicked, trackFollowed, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';
import RenewListingButton from '../listings/RenewListingButton';

interface Props {
  listing: Listing;
  nextBestAction?: NextBestAction;
}

export const COMPONENT_NAME = 'RenewListingPresentment';

export default function RenewListingPresentment({ listing, nextBestAction }: Props) {
  const trackingContext = useTrackingContext();
  useTrackImpression(COMPONENT_NAME, INSIGHT.RENEW_ELIGIBLE, listing.id);

  const relistDescription = listing.priceRecommendation?.priceMiddle?.display ?
    I18n.t(
      'discovery.listingsManagement.sellerListingCard.insights.renewEligible.descriptionWithPriceRec',
      { displayPrice: listing.priceRecommendation?.priceMiddle?.display },
    ) : I18n.t('discovery.listingsManagement.sellerListingCard.insights.renewEligible.description');

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__renew-eligible">
          <RCIcon icon={<ClockCounterClockwiseIcon weight="duotone" />} size="inline-prominent" spacing="right" />
          <RCTextUtility size="350">
            {nextBestAction ? <SanitizedRender html={nextBestAction.title ?? ''} /> : relistDescription}
          </RCTextUtility>
        </span>
        {!!nextBestAction?.subtitle && (
          <RCTextUtility size="350">
            <SanitizedRender html={nextBestAction.subtitle} />
          </RCTextUtility>
        )}
        <RenewListingButton
          listing={listing}
          label={nextBestAction?.ctaText ?? undefined}
          onClick={() => trackClicked(COMPONENT_NAME, INSIGHT.RENEW_ELIGIBLE, listing.id, trackingContext)}
          onRenewSuccess={(appliedPriceCents) => trackFollowed(
            COMPONENT_NAME, INSIGHT.RENEW_ELIGIBLE, listing.id, trackingContext, { appliedPriceCents },
          )}
        />
      </div>
    </>
  );
}
